import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import BaseAutocomplete from '../../../../../../shared/components/base-autocomplete/base-autocomplete';
import BaseRenderInput from '../../../../../../shared/components/base-autocomplete/components/base-render-input/base-render-input';
import { useBaseAutocompleteOnChange } from '../../../../../../shared/components/base-autocomplete/hooks/use-base-autocomplete-on-change.hook';
import { ActiveInactiveStatusEnum } from '../../../../../../shared/enums/active-inactive-status.enum';
import { convertToSentenceCase } from '../../../../../../shared/utils/convert-to-sentence-case/convert-to-sentence-case.util';
import { mapActiveInactiveStatusEnumToItemLabelModel } from '../../../../../../shared/utils/mapping/mapping.util';
import FormControl from '../../../../../shared/components/ui/FormControl';
import { castTo } from '../../../../../shared/utils/cast-to';
import { optionEquality } from '../../../../../shared/utils/option-equality/option-equality.util';
import { filterCampaignsByStatus } from '../../../../store/slices/campaigns.slice';
import { CampaignFiltersFormikModel } from '../../models/campaign-filters-formik.model';
import { CampaignFilterProps } from '../../types/campaign-filter.props';
import { withCampaignFilterValues } from '../with-campaign-filter-values/with-campaign-filter-values';

const StatusDropdown: FunctionComponent<CampaignFilterProps> = (
  props: PropsWithChildren<CampaignFilterProps>
) => {
  const {
    setFieldValue,
    campaignSelectFilters: { status },
  } = props;

  const optionsStatus = [
    ActiveInactiveStatusEnum.ACTIVE,
    ActiveInactiveStatusEnum.INACTIVE,
  ];

  const onStatusChange =
    useBaseAutocompleteOnChange<CampaignFiltersFormikModel>(
      'status',
      filterCampaignsByStatus,
      setFieldValue
    );

  return (
    <FormControl
      data-testid="status-dropdown-form-control"
      classes={{
        root: 'form-control-main',
      }}
    >
      <BaseAutocomplete
        multiple={false}
        disableClearable={false}
        freeSolo={false}
        id="status"
        onChange={onStatusChange}
        getOptionLabel={option => convertToSentenceCase(option.label)}
        options={optionsStatus.map(mapActiveInactiveStatusEnumToItemLabelModel)}
        isOptionEqualToValue={optionEquality}
        value={
          !isNaN(+status)
            ? optionsStatus
                .map(mapActiveInactiveStatusEnumToItemLabelModel)
                .find(item => castTo<number>(status) === item.id)
            : null
        }
        renderInput={params => (
          <BaseRenderInput
            {...params}
            errors={props.errors}
            id="status"
            label="Status"
            name="status"
            touched={props.touched}
          />
        )}
      />
    </FormControl>
  );
};

export default withCampaignFilterValues(StatusDropdown);
